module.exports = __webpack_public_path__ + "static/media/6.Chop saw.53c02202.jpg";